import { ReturoReport } from 'components/shop-reception/mobile/interfaces'

export const toReportsPayload = (reports: ReturoReport[]) => ({
  id: reports.map(report => report.id)
})
